var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObservationMedicale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.913 61.017",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 894",
    d: "M48.393 6.312a10.418 10.418 0 0 0-10.52 10.52 10.583 10.583 0 0 0 8.416 10.31v15.991a13.676 13.676 0 1 1-27.352 0V41.87a16.978 16.978 0 0 0 14.728-16.622V8.416a4.22 4.22 0 0 0-4.208-4.208h-2.1a1.988 1.988 0 0 1-2.1-2.1 1.988 1.988 0 0 0-2.1-2.1 1.988 1.988 0 0 0-2.1 2.1 6.2 6.2 0 0 0 6.312 6.312h2.1v16.828a12.624 12.624 0 1 1-25.248 0V8.416h2.1A6.2 6.2 0 0 0 12.624 2.1 1.988 1.988 0 0 0 10.52 0a1.988 1.988 0 0 0-2.1 2.1 1.988 1.988 0 0 1-2.1 2.1h-2.1A4.22 4.22 0 0 0 0 8.416v16.832A16.818 16.818 0 0 0 14.728 41.87v1.262a17.884 17.884 0 0 0 35.769 0v-15.99a10.583 10.583 0 0 0 8.416-10.31 10.418 10.418 0 0 0-10.52-10.52m1.473 11.993a1.91 1.91 0 0 1-1.473.631 1.265 1.265 0 0 1-.842-.21c-.21-.21-.421-.21-.631-.421a2.034 2.034 0 0 1 0-2.946c.21-.21.421-.421.631-.421a2.1 2.1 0 0 1 2.949 1.894 1.91 1.91 0 0 1-.631 1.473",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObservationMedicale);
export default __webpack_public_path__ + "static/media/observation-medicale.2ffb0da549dcf13c0d4693f524b90bd3.svg";
export { ForwardRef as ReactComponent };